import { Grid } from '@material-ui/core';
import styled from 'styled-components';

const Content = styled(Grid)`
  margin-top: 20px;
  background-color: #fff;
`;

const PaginationGrid = styled(Grid)`
  margin-top: 20px;
`;

export { Content, PaginationGrid };
